/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MealTierAdminDto } from '../models/MealTierAdminDto';
import type { Pagination1OfMealCategoryMealTierListedClientDto } from '../models/Pagination1OfMealCategoryMealTierListedClientDto';
import type { Pagination1OfMealTierListedAdminDto } from '../models/Pagination1OfMealTierListedAdminDto';
import type { PostMealTierAdminRequest } from '../models/PostMealTierAdminRequest';
import type { PutMealTierAdminRequest } from '../models/PutMealTierAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MealTiersService {
    /**
     * @returns Pagination1OfMealCategoryMealTierListedClientDto OK
     * @throws ApiError
     */
    public static getMealCategoryMealTiersClient({
        id,
        search,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        search?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealCategoryMealTierListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/mealtiers/mealcategory/{id}',
            path: {
                'id': id,
            },
            query: {
                'search': search,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealTiers`
     * @returns MealTierAdminDto OK
     * @throws ApiError
     */
    public static getMealTierAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<MealTierAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealtiers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealTiers`
     * @returns any OK
     * @throws ApiError
     */
    public static putMealTierAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutMealTierAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/mealtiers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealTiers`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteMealTierAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/mealtiers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewMealTiers`
     * @returns Pagination1OfMealTierListedAdminDto OK
     * @throws ApiError
     */
    public static getMealTiersAdmin({
        id,
        name,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        name?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealTierListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/mealtiers',
            query: {
                'id': id,
                'name': name,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageMealTiers`
     * @returns any OK
     * @throws ApiError
     */
    public static postMealTierAdmin({
        requestBody,
    }: {
        requestBody?: PostMealTierAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/mealtiers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
